import React from 'react';

import type { SelectOption } from '../../types/roles';
import SelectDropdown from '~/ui/3dbiaUI/SelectDropdown';
import BiaSelect from '~/ui/3dbiaUI/BiaSelect/BiaSelect';

interface ProviderNamesProps {
  providers: string[];
  provider: string | undefined;
  organization: string | undefined;
  onProviderClick: (providerName: string, orgName: string | undefined) => void;
}

const ProviderNames: React.FC<ProviderNamesProps> = ({ 
  providers, 
  provider, 
  organization, 
  onProviderClick 
}) => {
  console.log('providers', providers);
  
  const options: SelectOption[] = providers.map(provName => ({
    id: provName,
    name: provName,
  }));

  return (
    <BiaSelect
      className={`large ${providers.length <= 1 ? 'disabled' : ''}`}
      placeHolder='Select Provider'
      labelClass='d-none'
      value={provider}
      options={options}
      onChange={(provName) => onProviderClick(provName as string, organization)}
    />
  );
};

export default ProviderNames;
